import React from 'react';

const Alert = ({ type, message, visible }) => {
  if (!visible) return null;
  
  return (
    <div className={`alert alert-${type}`}>
      {message}
    </div>
  );
};

export default Alert;